export default {
  scheme:{
    message:{
      e_new: "Error create new ConceptScheme.  {{detail}}",
    },
    countUsed: "Total number of links to directory elements",
    inScheme: "Related concepts"
  },
  concept: {
    new: {
      title: "New Concept",
      cancelText: "Cancel",
      okText: "Create",
      },
    message: {
      ok_link: "Концепт добавлен.",
      ok_new:  "Создан новый концепт",
      ok_unlink: "Запись удалена.",
      e_detail: "Ошибка при получении дополнительной информации о концепте. {{detail}}",
      e_new: "Ошибка создания концепта.  {{detail}}",
    }  
  }  
}
